<template>
    <main id="innovation-sheet-showroom" v-if="displayContent">
        <div class="showroom-container" v-if="pictures.length > 0 || videos.length > 0">
            <sheet-block-picture-video-showroom :pictures="pictures" :videos="videos" v-if="showroomDisplayable" />
        </div>
        <template v-else>
            <div class="content-available-soon">
                {{ $t('content_available_soon') }}
            </div>
        </template>
    </main>
</template>

<script>
import { mapState } from 'vuex'
import speedTrackingMixins from "@/common/mixins/speedTracking"

import SheetBlockPictureVideoShowroom from "@/components/SheetBlock/SheetBlockPictureVideoShowroom";

export default {
    name: 'InnovationShowroomView',
    mixins: [
        speedTrackingMixins
    ],
    components: {
        SheetBlockPictureVideoShowroom,
    },
    data() {
        return {
            displayContent: false,
            showroomDisplayable: false,
            pictures: [],
            videos: [],
        }
    },
    computed: {
        ...mapState({
            productDatas: state => state.sheet.productDatas
        }),
    },
    created(){
        this.startLoading();

        // this.fetchMainVisual()
        let promisesArray = [
            this.fetchAllShowroomMedias(),
            this.getYoutubeVideo(),
        ];

        this.speedTrackingShowroom = new Date().getTime();

        Promise.all(promisesArray).then(() => {
            if(this.pictures.length > 0 || this.videos.length > 0)
                this.showroomDisplayable = true;

            this.stopLoading()
            this.displayContent = true;

            this.speedTrackingShowroomTrigger('innovation', this.productDatas.identifier, (this.productDatas.values.attachment_name || this.productDatas.values.name));
        });

    },
    methods: {
        async fetchAllShowroomMedias(){
            let mediasAttributes = [
                'studio',
                'application',
                'detail',
            ];

            for(const mediasAttribute of mediasAttributes)
                await this.fetchShowroomMedias(mediasAttribute)
        },
        async getYoutubeVideo(){
            if(this.productDatas.values.youtube_other !== undefined){
                const code=this.productDatas.values.youtube_other.code.replace('v=','')
                let youtube_embed = 'https://www.youtube.com/embed/'+code+'?autoplay=1';

                this.videos.push({
                    type: 'video',
                    src: 'https://img.youtube.com/vi/'+code+'/sddefault.jpg',
                    embed: youtube_embed,
                    thumb: 'https://i.ytimg.com/vi/' + code + '/hqdefault.jpg',
                })
            }
        },
    }
}
</script>


<style lang="scss">
#innovation-sheet-showroom {
    padding-top: 35px;
    padding-bottom: 40px;

    .showroom-container {
        padding-left: 30px;

        @media #{$mq_phone} {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
}
</style>

